export const STATUS_OK = 'ok';
export const STATUS_ERROR = 'error';
export const STATUS_PENDING = 'pending';

export const SESSION_STATUS_PENDING = 'pending';
export const SESSION_STATUS_PLAYING = 'playing';
export const SESSION_STATUS_DONE = 'done';

export const ACTION_LOGIN = 'user/login';
export const ACTION_LOGOUT = 'user/logout';
export const ACTION_START_SESSION = 'user/start-session';
export const ACTION_NEXT_WORD = 'user/next-term';
export const ACTION_SHOW_REPORT = 'user/show-report';
export const ACTION_LIST_COLLECTIONS = 'user/list-collections';
export const ACTION_ADD_TO_COLLECTION = 'user/add-to-collections';
export const ACTION_CREATE_COLLECTION = 'user/create-collection';

export const ACTION_LIST_REPO_CONTENTS = 'repo/list-contents';
export const ACTION_CHOOSE_COLLECTION = 'repo/choose-collection';
